/**
 * Correlation ID generation — v.1-D §7.3.
 *
 * Returns an RFC-4122 v4 UUID. Prefers `crypto.randomUUID` (universally
 * available in modern browsers + Node 16+); falls back to byte-shuffling
 * with `crypto.getRandomValues` when the host omits `randomUUID`.
 *
 * Ported verbatim by T304 from `frontend-v2/src/lib/correlation.ts` —
 * FR-023 requires a fresh correlation id per mutation invocation; this is
 * the sole producer.
 */
export function newCorrelationId(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // Set version 4 (high nibble of byte 6) and RFC variant (high two bits of byte 8).
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
